export interface TestimonialRenderProps {
    author: string;
    title: string;
    organization: string;
    quote: string;
}

const TestimonialRender = (props: TestimonialRenderProps) => {
    const { author, title, organization, quote } = props;

    return (
        <figure className="border-l-4 border-gray-100 pl-6">
            <blockquote className="text-2xl font-bold leading-tight tracking-tight p-0 border-l-0 md:text-4xl font-headline whitespace-pre-wrap">
                &ldquo;{quote}&rdquo;
            </blockquote>
            <figcaption className="mt-6 space-y-2 md:space-y-3">
                <span className="block h-xxs md:h-xs">{author}</span>
                <span className="block text-base md:text-lg">
                    {title ? `${title}` : ''}
                    {title && organization ? ', ' : ''}
                    {organization ? `${organization}` : ''}
                </span>
            </figcaption>
        </figure>
    );
};

export default TestimonialRender;
